import React from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import './new-emergency-modal.scss';
import { MapComponent } from '../building-blocks';

function NewEmergencyModal({
    show,
    handleSkip,
    handleProcess,
    emergency,
    total,
}: {
    show: boolean;
    total: number;
    handleSkip: () => void;
    handleProcess: () => void;
    emergency: {
        phone: string;
        longitude: number;
        latitude: number;
        battery: number;
        user: { medicalCard: { firstName: string } };
        source: string;
        state: string;
    };
}) {
    return (
        <Modal show={show} backdrop="static">
            <Modal.Header>
                <Modal.Title>
                    Увага! Нова подія! {total > 1 && <b>({total})</b>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    {emergency?.phone && (
                        <Row>
                            <Col>
                                Номер телефону: <b>{emergency.phone}</b>
                            </Col>
                        </Row>
                    )}
                    {emergency?.user?.medicalCard?.firstName && (
                        <Row>
                            <Col>
                                Ім'я:{' '}
                                <b>{emergency.user.medicalCard.firstName}</b>
                            </Col>
                        </Row>
                    )}
                    {emergency?.latitude && (
                        <Row>
                            <Col>Широта: {emergency.latitude}</Col>
                        </Row>
                    )}
                    {emergency?.longitude && (
                        <Row>
                            <Col>Довгота: {emergency.longitude}</Col>
                        </Row>
                    )}
                    {emergency?.state && (
                        <Row>
                            <Col>Область: {emergency.state}</Col>
                        </Row>
                    )}
                    {(emergency?.battery || emergency?.battery === 0) && (
                        <Row>
                            <Col>Заряд батареї: {emergency.battery}</Col>
                        </Row>
                    )}
                    {emergency?.source && (
                        <Row>
                            <Col>Канал зв'язку: {emergency.source}</Col>
                        </Row>
                    )}

                    <MapComponent styles={{
                        width: '100%',
                        height: '350px'
                    }} location={emergency}/>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleSkip}>
                    Пропустити
                </Button>
                <Button variant="primary" onClick={handleProcess}>
                    Опрацювати
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default NewEmergencyModal;
